var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShieldIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 78,
    viewBox: "0 0 62 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.5504 1.56643C33.1551 0.143782 30.9045 0.0158661 29.3567 1.27053C24.8854 4.89364 21.3561 7.16714 17.5653 8.7655C13.7592 10.3703 9.48647 11.3802 3.41354 12.231C1.50531 12.4985 0.0859375 14.1286 0.0859375 16.0531V44.0459C0.0859375 49.8314 2.61401 55.3374 7.01719 59.0645L26.7453 75.7676C29.686 78.2563 33.9923 78.1916 36.8573 75.6197L55.403 58.9711C59.5501 55.2478 61.9099 49.9107 61.9099 44.3216V16.9969C61.9099 15.1762 60.6362 13.6037 58.8541 13.2233C52.0404 11.7677 47.5356 10.3929 43.9726 8.65162C40.4847 6.94724 37.729 4.80622 34.5496 1.56748L34.5504 1.56643Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldIcon);
export default __webpack_public_path__ + "static/media/shieldIcon.18a37d28a0fdadb6cc17ed712ba31db0.svg";
export { ForwardRef as ReactComponent };